export const SearchBarPlacement = {
  NAVIGATION: 'navigation search bar',
  RESOURCES: 'resources search bar',
  GLOBAL_SEARCH_PAGE: 'global page search bar',
  PARTNERS: 'partners search bar',
  DATA_CENTERS: 'data centers search bar',
  ARTICLES: 'articles search bar',
  PRESS_RELEASES: 'press releases search bar',
  PRODUCT_FAMILY: 'product family search bar',
  ERROR: 'error page search bar',
};
